<template>
  <div>
    <b-row>
      <b-col>
        <RoleTab
            :items="items"
            :columns="columns"
            :captionTab = "captiontable"
            :isCalled="false"
            :isViewBtn="true"
            :selectedValue="selectedItem"
            @editItem="showEditDialog"
            v-model="selectedItem"
            :captionSpr="captionSport"
            :urls="urls"
            ref="EventTab"
        >
        </RoleTab>
      </b-col>
    </b-row>

    <b-modal ref="editModal" v-model="modalEditOpened" title="Редактирование роли" size="lg" hide-footer
             id="editModal">
      <div class="d-block">
        <b-input-group prepend="Наименование" class="mt-1" size="sm">
          <b-form-input type="text" :disabled="selectedItem.id!==null" placeholder="Укажите наименование" v-model="selectedItem.name"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.name">Указано пустое наименование</b-form-invalid-feedback>

        <b-input-group prepend="Описание" class="mt-1" size="sm">
          <b-form-input type="text" placeholder="Укажите описание" v-model="selectedItem.description"/>
        </b-input-group>
        <b-form-invalid-feedback :state="validValue.description">Указано пустое описание</b-form-invalid-feedback>

      </div>

      <div class="text-right">
        <b-button class="mt-1 mr-1" variant="outline-primary" @click="saveRole">Сохранить</b-button>
        <b-button class="mt-1" variant="outline-danger" @click="modalEditOpened=!modalEditOpened">Отменить
        </b-button>
      </div>

    </b-modal>

  </div>
</template>

<script>
import RoleTab from '../components/TabSpr.vue'
import http from '@/http-common'

export default {
  name: 'RolesPage',
  components: {RoleTab},
  data() {
    return {
      captiontable:'Роли',
      items: [],
      editItem: {},
      urls: {
        save: '/roles/save',
        delete: '/roles',
      },
      captionSport: {
        name: 'Роль',
        nameR: 'роли'
      },
      columns: [
        {key: 'name', label: 'Наименование'},
        {key: 'description', label: 'Описание'},
        {key: 'status', label: 'Статус'},
        {key: 'edit_field', label: '', firstClass: 'width10', sortable: false}
      ],
      selectedItem: {id: 0},
      modalEditOpened: false,
      validValue: {
        name: true,
        description: true,
        form: true,
      }
    }
  },
  created() {
    this.loadItems();
  },
  methods: {
    checkForm() {
      for (var key in this.validValue) {
        this.validValue[key] = true;
      }
      if (!this.selectedItem.name || this.selectedItem.name === '') {
        this.validValue.name = false;
        this.validValue.form = false;
      }
      if (!this.selectedItem.description || this.selectedItem.description === '') {
        this.validValue.name = false;
        this.validValue.form = false;
      }
    },
    loadItems() {
      var vm = this;
      http.get('/roles')
      .then((response) => {
        vm.items = response.data;
      })
      .catch((error) => console.log(error.message));
    },
    showEditDialog() {
      this.modalEditOpened = !this.modalEditOpened;
    },
    saveRole() {
      this.checkForm();
      if (this.validValue.form) {
        this.modalEditOpened = false;
        this.$refs.EventTab.save(this.selectedItem);
      }
    }
  }
}
</script>
